module.exports = __webpack_public_path__ + "static/media/loader.dd48f6d8.gif";